import { render, staticRenderFns } from "./IntegrationsMD.vue?vue&type=template&id=5960b67d&scoped=true"
import script from "./IntegrationsMD.vue?vue&type=script&lang=js"
export * from "./IntegrationsMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960b67d",
  null
  
)

export default component.exports